import React from 'react';
import IStatistic from '@/models/viewModels/IStatistic';
import css from 'styled-jsx/css';
import moduleStyles from './key-facts-bar.module.scss';

type Props = {
  keyFacts: IStatistic[];
  uniBackgroundColor: string;
};

function getStyles(uniBackgroundColor: string): { className: string; styles: JSX.Element } {
  return css.resolve`
    .key-facts-wrapper {
      background-color: ${uniBackgroundColor};
    }
  `;
}

export default function KeyFactsBar({ keyFacts = null, uniBackgroundColor }: Props) {
  const { className, styles } = getStyles(uniBackgroundColor);
  return (
    keyFacts.filter((stat) => stat.value).length > 0 && (
      <div
        id="key-facts-bar"
        className={`py-lg-2 pt-3 pb-4 key-facts-wrapper
       ${moduleStyles.key_facts_bar} ${className} `}
      >
        {styles}
        {keyFacts.map(
          (stat) =>
            stat.value && (
              <div key={stat.name} className={`${moduleStyles.stat_item} px-3`}>
                <div>{stat.name}</div>
                <div className={`${moduleStyles.stat_value}`}>{stat.value}</div>
              </div>
            ),
        )}
      </div>
    )
  );
}
